module.exports = __webpack_public_path__ + "media/images/lightbox/thumb-v-y-2-9071cc75ffbe07f06fb7e4782f0055eb.jpg";